/**
 * KAN-976: карточка остатка кошелька кабинета и кнопка пополнения.
 * KAN-1000: тарифов нет, с кошелька оплачивается только расход.
 */
import { Button } from '@/components/ui/button';
import { useWallet } from '@/hooks/useWallet';
import { formatRub } from '@/lib/wallet';

interface WalletBalanceCardProps {
  onTopup: () => void;
}

export function WalletBalanceCard({ onTopup }: WalletBalanceCardProps) {
  const { data, isLoading, isError } = useWallet();
  return (
    <section className="rounded-lg bg-white p-4 shadow sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-sm text-gray-500">Остаток</p>
          {isLoading && <p className="text-3xl font-semibold text-gray-300">...</p>}
          {isError && (
            <p className="text-sm text-red-600" role="alert">
              Не удалось загрузить баланс
            </p>
          )}
          {data && (
            <p
              data-testid="wallet-balance"
              className={Number(data.balance) > 0 ? 'text-3xl font-semibold text-gray-900' : 'text-3xl font-semibold text-red-600'}
            >
              {formatRub(data.balance)}
            </p>
          )}
        </div>
        <Button data-testid="wallet-topup-open" onClick={onTopup} disabled={!data}>
          Пополнить
        </Button>
      </div>
      <p className="mt-3 text-xs text-gray-500">
        Абонентской платы нет. С баланса списывается только расход: токены, голос,
        телефония, Telegram-аккаунты, прокси и базы.
      </p>
    </section>
  );
}
